import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import UnleashProvider from './context/UnleashProvider';
import { injectStore } from './network/api';

import { AnalyticsProvider } from 'context/AnalyticsContext';
import { PermissionsProvider } from 'context/PermissionsContext';
import { persistor, store } from './store';

injectStore(store);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});

function AppProvider({ children }: { children: React.ReactNode }) {
  return (
    <AnalyticsProvider>
      <PermissionsProvider>
        <QueryClientProvider client={queryClient}>
          <UnleashProvider>
            <Provider store={store}>
              <PersistGate loading={null} persistor={persistor}>
                {children}
              </PersistGate>
            </Provider>
          </UnleashProvider>
        </QueryClientProvider>
      </PermissionsProvider>
    </AnalyticsProvider>
  );
}

export default AppProvider;
